import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  privyToken: null,
  sessionId: null,
  isEurope: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setPrivyToken: (state, action) => {
      state.privyToken = action.payload;
    },
    setIsEurope: (state, action) => {
      state.isEurope = action.payload;
    },
  },
});

export const { setPrivyToken, setSessionId, setIsEurope } = authSlice.actions;

export const selectPrivyToken = (state) => state.auth.privyToken;
export const selectIsEurope = (state) => state.auth.isEurope;

export default authSlice.reducer;
